import React from "react";
// import ModalPopupComponent from "../../ModalPopupComponent/theme12/ModalPopupComponent";
import ModalPopupComponent from "../../../componentsV2/modalPopUp/index";
import RegisterComponent from "./Registration";
import { withRouter } from "next/router";
import { tokenExpiry } from "../../../../common/lib/tokenExpiry";
import { checksession } from "../../../lib/checksession.js";
import LoginComponent from "./login";
class Theme1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupPage:
        this.props.data.directOpenLinkPopup.popupPage || "LoginWithMobile",
      isCheckingResetToken: false,
      forgotPasswordEmail: "",
      forgotPasswordErr: "",
      verifyOtpMobile: undefined,
      popupPage: props.data.directOpenLinkPopup.popupPage || "LoginWithMobile",
      popupCompoenet:
        props.data.directOpenLinkPopup.popupCompoenet || "LoginWithMobile",
      isFirstName: "",
      isAccessToken: "",
      isLoading: true,
      email: "",
      initialStep: "",
      isRegister: ""
    };
    this.registerRef = React.createRef();
  }

  async componentDidMount() {
    console.log("vedant props", this.props)
    await this.checkSessionApi();
    const currentPath = window.location.pathname;
    if (!localStorage.getItem("loginReferrer")) {
      localStorage.setItem("loginReferrer", currentPath);
    }
    this.checkResetToken();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.data.directOpenLinkPopup !== this.props.data.directOpenLinkPopup
    ) {
      this.setState({
        popupType: this.props.data.directOpenLinkPopup || "LoginWithMobile",
        popupPage:
          this.props.data.directOpenLinkPopup.popupPage || "LoginWithMobile",
        popupCompoenet:
          this.props.data.directOpenLinkPopup.popupCompoenet || "login",
      });
    }

    const prevToken = prevProps.router?.query?.resettoken;
    const currToken = this.props.router?.query?.resettoken;
    if (prevToken !== currToken) {
      this.checkResetToken();
    }
  }

  checkSessionApi = async () => {
    try {
      const res = await checksession();
      const session = res;

      // console.log("vedant", session)

      if (session) {
        this.setState({
          isAccessToken: session?.accessToken,
          isFirstName: session?.first_name,
          email: session?.email,
          isRegister: session?.rg_status,
          isLoading: false,
          initialStep: (session?.accessToken && session?.rg_status === "R") ? "profileComplete" : "email"
        });
      }
      else {
        this.setState({ isLoading: false });
      }
    } catch (err) {
      console.error("Session check failed:", err);
      this.setState({ isLoading: false });
    }
  };

  checkResetToken = () => {
    const router = this.props.router;
    const props = this.props;
    if (
      router &&
      router.query &&
      router.query.resettoken &&
      router.query.resettoken !== "" &&
      router.query.resettoken !== null
    ) {
      this.setState({ isCheckingResetToken: true });
      let response = {
        resettoken: router?.query?.resettoken,
        site_id: props?.data?.home?.data?.site?.id,
      };
      if (typeof tokenExpiry === "function") {
        tokenExpiry(response).then((resp) => {
          if (resp && resp.data.status) {
            this.setState({
              popupType: "ResetPassword",
              popupPage: "ResetPassword",
              popupCompoenet: "login",
              isCheckingResetToken: false,
            });
          } else {
            this.setState({
              popupType: "resettokenExpiry",
              popupPage: "resettokenExpiry",
              popupCompoenet: "login",
              isCheckingResetToken: false,
            });
          }
        });
      }
    }
  };

  open = () => {
    this.setState({
      popupType: "LoginWithMobile",
      popupCompoenet: "login",
      popupPage: "LoginWithMobile",
    });
    // if (this.props.data.onClickCross) {
    //   this.props.data.onClickCross();
    // }
  };

  openRegisterPopup = () => {
    this.setState({
      popupType: "Register",
      popupCompoenet: "Register",
      popupPage: "Register",
    });
    if (this.props.data.onClickCross) {
      this.setState({ isLoading: true })
      this.props.data.onClickCross();
    }
  };

  render() {

    const {
      logincss: styles,
      modalCss,
      basiccss12,
      isMobile,
      onClickCross,
      isPopup,
      IsdCodeDropdownCss,
      dropdownStylesTheme12,
    } = this.props.data;

    // console.log("vedamodal",modalCss)

    const shouldShowPopup = isPopup !== undefined ? isPopup : true;

    const router = this.props.router;

    const handleClose = () => {
      if (onClickCross) onClickCross();
      if (step === "profileComplete") {
        window.location.reload();
      }
    };

    if (this.state.isCheckingResetToken) {
      return <div />; // or a loader/spinner if you want
    }
    console.log("Current Step:", this.registerRef?.current?.state?.currentStep);
    const step = this.registerRef.current?.state?.currentStep || "";

    return (

      <div
        className={`${styles?.basiccss12?.registration_main} ${step === "changeEmail" ? styles?.basiccss12?.change_email : ""
          }`}
      >
        {
          !this.state.isLoading && (
            <ModalPopupComponent
              isMobile={isMobile}
              isPopup={shouldShowPopup}
              onClosePopup={handleClose}
              modalCss={modalCss?.modalCssTheme12 ? modalCss.modalCssTheme12 : modalCss}
              showCrossButton={!isMobile}
              showBackButton={
                isMobile
              }
              onBackPopup={() => {
                if (this.registerRef.current) {
                  const step = this.registerRef.current.state.currentStep;
                  if (step === "email") {
                    if (onClickCross) onClickCross();
                  }
                  if (step === "profileComplete") {
                    handleClose()
                  }
                  else {
                    this.registerRef.current.handleBack();
                  }
                }
              }}
            >
              {/* <LoginComponent
            ref={this.registerRef}
            {...this.props}
            styles={styles.registercssTheme12}
            onStepChange={(step) =>
              this.setState({ currentStep: step })
            } 
            isMobile={isMobile}
          /> */}
              <RegisterComponent
                {...this.props}
                ref={this.registerRef}
                styles={styles.registercssTheme12}
                IsdCodeDropdownCss={styles?.isdDropdownStyles12}
                dropdownStylesTheme12={
                  this.props.data.logincss.dropdownStylesTheme12
                }
                onStepChange={(step) => this.setState({ currentStep: step })}
                isMobile={isMobile}
                isAccessToken={this.state.isAccessToken}
                isFirstName={this.state.isFirstName}
                email={this.state.email}
                initialStep={this.state.initialStep}
                isRegister={this.state.isRegister}
              />
            </ModalPopupComponent>
          )
        }

      </div>
    );
  }
}

export default withRouter(Theme1);
